import type { UseQueryResult } from '@tanstack/react-query';
import type { ApiEndpoints } from '@avisoma/shared';
import { SortableTable } from '../../components/SortableTable';
import { Link } from '../../components/Link';
import FileSize from '../../components/FileSize';
import { Button } from '../../catalyst/button';
import { formatDateTime } from '../../lib/dateFormat';
import { SectionCard } from './SectionCard';
import { QueryStateGuard } from './QueryStateGuard';

type UploadQueryResult = UseQueryResult<ApiEndpoints<string>['/api/uploads/:id']['GET']['response']>;

export function DocumentsDetailsSection({ uploadQuery }: { uploadQuery: UploadQueryResult }) {
  return (
    <QueryStateGuard query={uploadQuery} noDataMessage="No documents found.">
      {(data) => {
        const documents = data.documents;
        if (!documents) {
          return <div className="text-sm text-gray-500 dark:text-zinc-400">No documents found.</div>;
        }
        return (
          <SectionCard
            title="Documents Details"
            actions={
              <Button href={`/documents?uploadId=${data.item?.id}`}>View All Documents</Button>
            }
          >
            <SortableTable
              storageId="upload-documents"
              data={documents}
              columns={[
                { accessor: 'id', label: 'ID' },
                {
                  accessor: 'documentId',
                  label: 'Document ID',
                  render: (row) => <Link to={`/documents/${row.documentId}`}>{row.documentFileName}</Link>,
                },
                { accessor: 'pageCount', label: 'Page Count', render: (row) => row.pageCount },
                {
                  accessor: 'documentBytes',
                  label: 'Document Bytes',
                  render: (row) => <FileSize bytes={row.documentBytes} />,
                },
                { accessor: 'pageBytes', label: 'Page Bytes', render: (row) => <FileSize bytes={row.pageBytes} /> },
                {
                  accessor: 'pageCreatedAt',
                  label: 'Page Created',
                  render: (row) => <div>{formatDateTime(row.pageCreatedAt)}</div>,
                },
              ]}
              rowKey={(row) => row.id.toString()}
            />
          </SectionCard>
        );
      }}
    </QueryStateGuard>
  );
}
